import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: PointsDistribution = {
  PointsDistributionsID: null,
  CreateTimestampAtUTC: '',
  DistributionName: '',
  NumUsersIncluded: null,
  IsCancelled: false,
  DistributionTimestampAtUTC: '',
  CampaignID: null,
  EarningTitle: '',
  IconImageID: null,
  TargetGroupID: null,
  TenantID: '',
  TotalPointsToDistribute: null,
  iconImageUrl: '',
  segmentName: '',
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    EarningTitle: ''
  },
  translations: {
    EarningTitle: '',
    LanguageCode: null
  }
}

export const pointsDistributionSlice = createSlice({
  name: 'pointsDistribution',
  initialState,
  reducers: {
    setPointsDistributionInfo: (
      state,
      action: PayloadAction<PointsDistribution>
    ) => {
      return action.payload
    },
    setPointsDistributionSelectedTranslations: (
      state,
      action: PayloadAction<SetPointsDistributionTranslationParms>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          EarningTitle: action.payload.translations?.EarningTitle ?? null,
          LanguageCode: action.payload.selectedLanguage
        }
      }
    }
  }
})
export const {
  setPointsDistributionInfo,
  setPointsDistributionSelectedTranslations
} = pointsDistributionSlice.actions
export const pointsDistributionReducer = pointsDistributionSlice.reducer
